export default __webpack_public_path__ + "static/media/image-header.d200a358.jpg";